import { css } from 'lit'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'


export const cscCategoryChips = {
  gap: css`var(--csc-category-chips-gap, ${csSpacing.spacing05})`,
}

export const style = css`
  .category-chips-wrapper {
    display: grid;
    grid-template-columns: auto 1fr auto;
    align-items: center;
    width: 100%;
  }
  
  .scroll-btn {
    z-index: 1;
  }
  
  .chips-container {
    overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;
    display: flex;
    flex-wrap: nowrap;
    scrollbar-width: none;
    -ms-overflow-style: none;
    gap: ${cscCategoryChips.gap};
  }
  
  .chips-container::-webkit-scrollbar {
    display: none;
  }
`
